import * as React from 'react'

import { Box, Icon, useToggle } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

interface ExpandableBlockProps {
  title: React.ReactNode
  defaultOpen?: boolean
}

const ExpandableBlock = ({
  title,
  defaultOpen = false,
  children,
}: React.PropsWithChildren<ExpandableBlockProps>) => {
  const [open, toggle] = useToggle(defaultOpen)
  const direction = open ? 'down' : 'right'

  return (
    <Box>
      <Box flexDirection="row">
        <Box onClick={toggle(!open)}>
          <Icon.Small icon={`caret-${direction}`} />
        </Box>
        {title}
      </Box>
      <Box paddingLeft="s6">
        {open && (
          <Box
            paddingLeft="s40"
            border={{
              left: {
                color: 'grey400',
                style: 'solid',
                width: 's1',
              },
            }}
          >
            {children}
          </Box>
        )}
      </Box>
    </Box>
  )
}

export default observer(ExpandableBlock)
